<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright mtop"><img alt="" src="images/logo.jpg"/></p>
<p class="copyright mtop"><span class="no-style-override-15">Copyright © 1984 by Thomas F. Monteleone</span></p>
<p class="copyright mtop"><span class="no-style-override-15">All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</span></p>
<p class="copyright mtop"><span class="no-style-override-15">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></span></p>
<p class="copyright mtop"><span class="no-style-override-15">Diversion Books</span></p>
<p class="copyright"><span class="no-style-override-15">A division of Diversion Publishing Corp.</span></p>
<p class="copyright"><span class="no-style-override-15"><a href="http://www.diversionbooks.com" target="_blank">www.diversionbooks.com</a></span></p>
<p class="copyright mtop">Copyright © 1984</p>
<p class="copyright">First Diversion Books edition, 2020</p>
<p class="copyright"><span class="no-style-override-15">eBook ISBN: 978-1-63576-760-5</span></p>
<p class="copyright mtop"><span class="no-style-override-15">Printed in The United States of America</span></p>
<p class="copyright mtop"><span class="no-style-override-15">1 3 5 7 9 10 8 6 4 2</span></p>
<p class="copyright mtop"><span class="no-style-override-15">Library of Congress cataloging-in-publication data is available on file.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// f004.vue?7ee51aca